import styled from "styled-components";
const EthicalManagementSub = ({ title, contents }) => {
  return (
    <Div>
      <div>{title}</div>
      <div>
        <ul>
          {contents?.map((x, idx) => {
            return <li key={idx}>{x}</li>;
          })}
        </ul>

      </div>

    </Div>
  );
};
export default EthicalManagementSub;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  overflow: hidden;
  & > div:first-child {
    font-size: 1.15rem;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.dark};
    padding: 1.1rem 1.5rem;
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  }
  & > div:nth-child(2) {
    padding: 1.1rem 1.5rem 1.25rem;
    & > ul {
      display: flex;
      flex-direction: column;
      list-style: none;
      gap: 0.5rem;
      margin: 0;
      padding: 0;
      & > li {
        position: relative;
        padding-left: 1.1rem;
        line-height: 1.7;
        color: ${({ theme }) => theme.colors.monotone.dark};
        &:before {
          content: "";
          position: absolute;
          top: 0.7em;
          left: 0;
          background-color: ${({ theme }) => theme.colors.accent};
          height: 0.4rem;
          width: 0.4rem;
          border-radius: 50%;
        }
      }
    }
  }
`;
